function PopupAlert({ heading, icon, open, action }) {
  return (
    <div>
      <div className="dboard-log-out-alert-main">
        <div className="dboard-log-out-alert-main-content">
          <div className="inner-dboard-log-out-alert-main-content">
            <div className="dashboard-log-out-alert-icon">
              {" "}
              <div>
                <i class={icon ? icon : "fa-solid fa-exclamation"}></i>
              </div>{" "}
            </div>
            <div> {heading ? heading : "Are you sure?"} </div>
            <div>
              <button onClick={action && action} className="yes">
                Yes
              </button>{" "}
              <button className="cancel" onClick={() => open(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PopupAlert;
